export const SET_FLOW_UI_FLAG = 'SET_FLOW_UI_FLAG';
export const CLEAR_FLOWS = 'CLEAR_FLOWS';
export const SET_FLOWS = 'SET_FLOWS';
export const SET_FLOW_ITEM = 'SET_FLOW_ITEM';
export const DELETE_FLOW = 'DELETE_FLOW';
